import React, { PropsWithChildren } from 'react';
import Dialog from '../dialog';
import { TDialogConfirm } from './index.types';
import Button from 'components/control/button/button';
import { EButtonType } from 'components/control/button/button.types';
import { DialogBodyControlButtons } from './index.styled';

const DialogConfirm = <T,>({
                             setIsDialogOpen,
                             isDialogOpen,
                             title,
                             onOk,
                             onCancel,
                             labels,
                             children,
                             buttonType,
                           }: PropsWithChildren<TDialogConfirm<T>>) => {

  return (
    <Dialog
      isDialogOpen={isDialogOpen}
      setIsDialogOpen={setIsDialogOpen}
      title={title}
    >
      {children}
      <DialogBodyControlButtons>
        <Button
          onClick={() => {
            onCancel && onCancel();
            setIsDialogOpen(false);
          }}
          styleType={EButtonType.Outline}
        >
          {labels?.onCancel ?? 'Cancel'}
        </Button>
        <Button
          onClick={() => {
            onOk && onOk();
            setIsDialogOpen(false);
          }}
          styleType={buttonType || EButtonType.Primary}
        >
          {labels?.onOk ?? 'Confirm'}
        </Button>
      </DialogBodyControlButtons>
    </Dialog>
  );
};

export default DialogConfirm;
